// CMS API: Fetch CMS content (public)
import api from './api';

export async function getCMS() {
  const res = await api.get('/api/cms');
  return res.data;
}

// Optionally, fetch settings (if needed for template URL)
export async function getSettings() {
  const res = await api.get('/api/cms/settings');
  return res.data;
}
